import httpStore from "@/api/httpStore.js";

// Get applications for a product
export function getApplications(unificado) {
  return httpStore
    .post(`applications/get_applications/${unificado}`, {
      datatable: {
        page: 0,
        qtyPerPage: 1000,
        orderDir: "desc",
        orderCol: null
      },
      filters: {
        make: null,
        model: null,
        year: null,
        engine: null
      }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Add new applications (incremental - doesn't remove existing)
export function addApplications(unificado, vehiclesToAdd) {
  return httpStore
    .post(`applications/add_applications/${unificado}`, {
      vehiclesToAdd
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Save applications (legacy - replaces all)
export function saveApplications(unificado, selectedVehicles) {
  return httpStore
    .post(`applications/save_applications/${unificado}`, {
      selectedVehicles
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Delete applications
export function deleteApplications(unificado, applicationIds) {
  const ids = Array.isArray(applicationIds)
    ? applicationIds.map(id => ({ id }))
    : [{ id: applicationIds }];

  return httpStore
    .post(`applications/delete_vehicle_application/${unificado}`, { id: ids })
    .then(res => res.data);
}

// Save notes for a single application
export function saveApplicationNotes(applicationId, notes) {
  return httpStore
    .post("applications/save_notes_single", {
      newNote: { id: applicationId, notes }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Save notes for multiple applications (bulk)
export function saveBulkNotes(applicationIds, notes) {
  return httpStore
    .post("applications/save_notes_general", {
      note: notes,
      selection: applicationIds.map(id => ({ id }))
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Update quantity required for multiple applications (bulk)
export function updateBulkQuantity(applicationIds, quantity) {
  return httpStore
    .post("applications/update_required", {
      selection: applicationIds.map(id => ({ id })),
      newQtyRequired: quantity
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Batch update applications (add, remove, update in one call)
export function batchUpdateApplications(unificado, updates) {
  return httpStore
    .post(`applications/batch_update/${unificado}`, {
      vehiclesToAdd: updates.vehiclesToAdd || [],
      applicationsToRemove: updates.applicationsToRemove || [],
      applicationsToUpdate: updates.applicationsToUpdate || []
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Mark applications as verified
export function markApplicationVerified(oem) {
  return httpStore
    .get(`applications/verify/${oem}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Remove verification
export function removeVerification(oem, id) {
  return httpStore
    .delete(`applications/verification/${oem}/${id}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Add entire vehicle family by catalog code
export function addFamilyApplications(unificado, catalogCode) {
  return httpStore
    .post(`applications/add_family/${unificado}`, {
      catalog_code: catalogCode
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Remove entire vehicle family from a product's applications
export function removeFamilyApplications(unificado, catalogCode) {
  return httpStore
    .post(`applications/remove_family/${unificado}`, {
      catalog_code: catalogCode
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
